import React from "react" ;
import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";
import {getMyContributorsRouterLink, PATH_MY_CONTRIBUTORS_ROOT} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import {Route, Switch} from "react-router-dom";
import MyContributorsSubmenu from "root/Wieldy/ApplicationModules/MyContributors/Sidebar/MyContributorsSubmenu";

const MyContributorsAppSidebar= (props) =>
{
    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default='mycontributors'>
                        <AppSidebarMenuItem link={getMyContributorsRouterLink('')} title='Contributors' iconName='icon-family' name='mycontributors'/>
                    </AppSidebarGroup>

                </ul>

                <Switch>
                    <Route path={PATH_MY_CONTRIBUTORS_ROOT} render={(thisprops) => <MyContributorsSubmenu {...thisprops}/>}/>
                    <Route exact path={PATH_MY_CONTRIBUTORS_ROOT} render={(thisprops) => <MyContributorsSubmenu {...thisprops}/>}/>
                </Switch>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default MyContributorsAppSidebar;
